(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exports(
            require('jquery'),
            require('lodash')
        );

    } else {

        RivalIQ.utils.async = exports(
            window.$,
            window._
        );
    }

    function exports($, _) {

        const async = {};

        /**
         * Wraps a deferred into a callback format.
         * @param deferred
         * @returns {Function}
         */
        const deferredToCallback = async.deferredToCallback = function (deferred) {

            return function (error, result) {

                if (error) {

                    return deferred.reject(error);
                }

                deferred.resolve(result);
            };
        };

        /**
         * Wraps a callback into a deferred format.
         * @type {Function}
         */
        async.callbackToDeferred = function (callback, deferred) {

            deferred = deferred || new $.Deferred();

            deferred
                .done(function () {

                    callback.apply(null, _.flattenDeep([null].concat(arguments)));
                })
                .fail(function () {

                    callback.apply(null, arguments);
                });

            return deferred;
        };

        /**
         * Invokes a function in synchronous or asynchronous modes.
         * @type {Function}
         * @param [{...*}] arguments
         */
        async.invoke = function (fn, deferred) {

            let error = null;
            let result = null;
            const callback = deferredToCallback(deferred);
            const args = Array.prototype.slice.call(arguments, 2);

            if (fn.length > 0) {
                return _.partial(fn, callback).apply(this, args);
            }

            try {

                result = fn.apply(this, args);
            } catch (e) {

                error = e;
            } finally {

                callback(error, result);
            }
        };

        /*
         * Returns a wrapper function that returns a deferred if called without
         * a callback
         */
        async.deferredOrCallback = function (fn) {
            return function () {
                let args = Array.prototype.splice.call(arguments, 0);
                const callback = _.last(args);
                let deferred;

                if (!_.isFunction(callback)) {
                    deferred = new $.Deferred();
                    args = args.concat(async.deferredToCallback(deferred));
                }

                fn.apply(this, args);

                return deferred;
            };
        };

        return async;
    }
})();
